import { PhoneOutlined } from '@ant-design/icons';
import { createSelector } from '@reduxjs/toolkit';
import { reduxEqualityFunction } from 'library/helpers/utility';
import React, { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Flex, Row, Typography } from 'zui/Antd';
import ViewMoreToggle from '../ViewMoreToggle';
import { peopleActions } from 'reduxStore/people/slice';

const { Text } = Typography;

// Selector to get person by ID
const selectPersonByID = createSelector(
	[(state) => state.People.data, (_, personID) => personID],
	(people, personID) => people.find((person) => person.personID === personID) || {}
);

const PeopleContactsPanel = ({ personID }) => {
	const dispatch = useDispatch();

	const [showAll, setShowAll] = useState(false);
	const maxItemsToShow = 4; // Limit of items to show initially

	const person = useSelector((state) => selectPersonByID(state, personID), {
		equalityFn: reduxEqualityFunction
	});

	// Load contact data on component mount
	useEffect(() => {
		dispatch(peopleActions.loadPeopleContact({ personID }));
	}, [personID, dispatch]);

	// Determine the number of contacts to display based on showAll state
	const visibleContacts = showAll ? person.contacts?.data : person.contacts?.data.slice(0, maxItemsToShow);

	return (
		<Fragment>
			{/* // If no contacts data is available, return null */}
			{visibleContacts?.data === 0 && <Text type='secondary'>No contacts available.</Text>}

			<Row gutter={[16, 16]}>
				{visibleContacts &&
					visibleContacts.length > 0 &&
					visibleContacts.map((contact, index) => (
						<Col span={24} key={contact.contactID}>
							<Flex align='center' justify='start' gap={16}>
								<PhoneOutlined style={{ fontSize: '24px' }} />
								<Flex vertical>
									<Text type='secondary' style={{ lineHeight: '20px' }}>
										Contact
									</Text>
									<Text strong style={{ lineHeight: '20px' }}>
										{contact.contactInformation}
									</Text>
								</Flex>
							</Flex>
						</Col>
					))}
			</Row>

			{person.contacts?.data.length > maxItemsToShow && (
				<ViewMoreToggle
					data={person.contacts?.data}
					maxItemsToShow={maxItemsToShow}
					onToggle={(showAll) => setShowAll(showAll)}
				/>
			)}
		</Fragment>
	);
};

export default PeopleContactsPanel;
